import { useSearch } from "@tanstack/react-router";
import { Button } from "antd";
import { useGetIncomingPostbackQuery } from "api/TenantSlug/IncomingPostback/hooks.ts";
import { IncomingPostbackTestForm } from "components/Forms/IncomingPostbackTestForm/IncomingPostbackTestForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";
import { getDrawerSearchParams } from "utils/drawerHelpers";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`incomingPostbackTest-id`]: string;
}

export const IncomingPostbackTestDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.incoming-postback-test");
    const id = DrawerId.IncomingPostbackTest;

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const incomingPostbackId = searchParams[`${id}-id`];

    const getIncomingPostbackQuery = useGetIncomingPostbackQuery(
        incomingPostbackId,
        {},
        {
            enabled: !!incomingPostbackId,
        }
    );

    const incomingPostback = getIncomingPostbackQuery.data?.incomingPostback;

    if (!incomingPostback) {
        return <></>;
    }

    return (
        <Drawer
            loading={getIncomingPostbackQuery.isLoading}
            drawerId={id}
            title={<DrawerTitle mainTitle={incomingPostback.name} subTitles={[]} />}
            searchParamsToClean={getDrawerSearchParams(id, "id")}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={FormId.IncomingPostbackTestForm}>
                    {t("actions.run_test")}
                </Button>
            }
        >
            <DrawerContent>
                <IncomingPostbackTestForm incomingPostback={incomingPostback} />
            </DrawerContent>
        </Drawer>
    );
};
